/**
 * Functionality associated with the Product Feature Animations.
 *
 * @package Qustodio_Theme\Scripts
 */

const productFeatureAnimation = () => {
  let animations = [];

  const init = () => {
    animations = document.querySelectorAll('.qusd-pfa');
  };

  const stop = () => {
    animations.forEach((animation) => {
      animation.classList.remove('qusd-pfa--animation-playing');
    });
  };

  const play = () => {
    animations.forEach((animation) => {
      animation.classList.add('qusd-pfa--animation-playing');
    });
  };

  let isRestarting = null;

  /**
   * Fixes a bug in Safari (doesn't re-calculate dimensions on window resize).
   *
   * Safari doesn't re-calculate dimensions in percentages inside CSS
   * animations when the window resizes. For Safari to re-calculate the
   * dimensions, we need to stop the animations and start them again. We do
   * this by removing and adding the CSS class that contains the 'animation'
   * property in all the elements of the product feature animations.
   */
  const restart = () => {
    stop();
    clearTimeout(isRestarting);
    /* Some time needed between removing and adding the class for Safari to
       re-process the animation. */
    isRestarting = setTimeout(play, 200);
  };

  return {
    init,
    restart,
  };
};

export default productFeatureAnimation();
